// Gemini can put invented pronunciation wrappers in its written transcript.
// Remove only language-phrase wrappers for display, retaining the spoken words.
export function cleanTutorTranscriptDisplay(text: string): string {
  const phraseTags = /<\/?([a-z][\w-]*_phrase)(?=[\s/>])(?:[^>"']|"[^"]*"|'[^']*')*>/gi;
  const names = new Set(Array.from(text.matchAll(phraseTags), (match) => match[1].toLowerCase()));
  const cleaned = text.replace(phraseTags, "");

  // A stream may end partway through an opening tag's attributes or a closing
  // tag's name. Keep the preceding phrase visible while that wrapper arrives.
  const pendingTag = /<\/?([a-z][\w-]*)(?:\s[^<]*)?$/i.exec(cleaned);
  if (pendingTag) {
    const name = pendingTag[1].toLowerCase();
    if (
      name.endsWith("_phrase") ||
      (pendingTag[0].startsWith("</") && Array.from(names).some((known) => known.startsWith(name)))
    ) {
      return cleaned.slice(0, pendingTag.index);
    }
  }
  return cleaned;
}
